import React from "react";
import styles from "./label-plus-input-and-dropdown.module.scss";
import { TimeIntervalInputAndDropDownWrapper } from "../time-interval-input-and-dropdown-wrapper/time-interval-input-and-dropdown-wrapper";

const cssClassName = "label-plus-input-and-dropdown";

interface LabelPlusInputAndDropDownPropTypes {
  labelText: string;
  intervalInSeconds: number;
  callback: (timeIntervalInSeconds: number) => void;
}

export const LabelPlusInputAndDropDown = ({ labelText, intervalInSeconds, callback}: LabelPlusInputAndDropDownPropTypes) => {
  return (
    <div>
      <div className={styles[`${cssClassName}__extra-margin-bottom`]}>
        <div className={styles[`${cssClassName}__attribute-name`]}>{labelText}</div>
      </div>
      <TimeIntervalInputAndDropDownWrapper intervalInSeconds={intervalInSeconds} callback={callback} />
    </div>
  )
}